/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LanguageToolCheckResponse } from '../models/language-tool-check-response';
import { LanguageToolCheckRequest } from '../models/language-tool-check-request';
@Injectable({
  providedIn: 'root',
})
class LanguagetoolkorrekturService extends __BaseService {
  static readonly languagetoolkorrekturCreatePath = '/languagetoolkorrektur';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  languagetoolkorrekturCreateResponse(data: LanguageToolCheckRequest): __Observable<__StrictHttpResponse<LanguageToolCheckResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/languagetoolkorrektur`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LanguageToolCheckResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  languagetoolkorrekturCreate(data: LanguageToolCheckRequest): __Observable<LanguageToolCheckResponse> {
    return this.languagetoolkorrekturCreateResponse(data).pipe(
      __map(_r => _r.body as LanguageToolCheckResponse)
    );
  }
}

module LanguagetoolkorrekturService {
}

export { LanguagetoolkorrekturService }
